import React, { useState, useEffect } from 'react';
import { oneOf } from 'prop-types';
import { useLazyDataModel, params, string as stringType, arrayOf } from '@thd-nucleus/data-sources';
import { Checkmark } from '@one-thd/sui-icons';
import {
  Button,
  Typography,
  Input,
  FormStatusMessage
} from '@one-thd/sui-atomic-components';
import { PROMO_TYPES, SUBSCRIPTION_TYPES, SOURCE_ID, SUCCESS_STATUS } from '../../constants';

export const EmailSignupForm = ({ promotionType }) => {
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isSignedUp, setIsSignedUp] = useState(false);

  const handleChange = (event) => {
    // eslint-disable-next-line max-len
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRegex.test(event.target.value)) {
      setEmail(event.target.value);
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
    }
  };

  const [submitEmailForm, response] = useLazyDataModel('preferencesEmail', {
    variables: {
      sourceId: SOURCE_ID,
      subscriptionType: [SUBSCRIPTION_TYPES[promotionType]]
    }
  });

  const loading = response?.loading;
  const responseStatus = response?.data?.preferencesEmail?.responseStatus;

  const submitForm = async (evt) => {
    evt.preventDefault();
    if (loading) { return; }

    if (evt.target[0]) {
      evt.target[0].focus();
      evt.target[0].blur();
    }
    if (isEmailValid) {
      LIFE_CYCLE_EVENT_BUS.trigger('promotions-email-signup.submit');
      submitEmailForm({ variables: { emailId: email } });
    }
  };

  useEffect(() => {
    if (!loading && typeof responseStatus !== 'undefined') {
      setIsSignedUp(responseStatus === SUCCESS_STATUS);
    }
  }, [responseStatus, loading]);

  if (isSignedUp) {
    return (
      <div className="sui-my-4">
        <span className="sui-input-base-root sui-gap-2">
          <Checkmark color="success" />
          <Typography color="success" className="sui-col-2 sui-my-3">
            Thanks for signing up! You&apos;ll receive your first specials email soon.
          </Typography>
        </span>
      </div>
    );
  }

  return (
    <form
      className="sui-inline-flex sui-gap-2"
      name="emailSignup"
      onSubmit={submitForm}
    >
      <div style={{ width: '380px' }}>
        <Input
          defaultValue={email}
          inputProps={{ 'data-testid': 'email-input' }}
          id="email"
          type="email"
          placeholder="Enter your email"
          validationTextClassName="sui-text-danger"
          disabled={loading}
          validateOnBlur
          onChange={handleChange}
          status={isEmailValid ? 'default' : 'error'}
          fullWidth
        />
        <FormStatusMessage id="input-error-message" className="sui-text-danger" hidden={isEmailValid}>
          Please format your email as yourname@email.com
        </FormStatusMessage>
      </div>
      <Button
        variant="secondary"
        type="submit"
        disabled={loading}
        style={{ width: '150px' }}
      >Sign Up
      </Button>
    </form>
  );
};

EmailSignupForm.propTypes = {
  promotionType: oneOf(PROMO_TYPES).isRequired,
};

EmailSignupForm.displayName = 'EmailSignupForm';

EmailSignupForm.dataModel = {
  preferencesEmail: params({
    subscriptionType: arrayOf(stringType().isRequired()),
    sourceId: stringType().isRequired(),
    emailId: stringType().isRequired()
  }).mutation().shape({
    responseStatus: stringType().isRequired()
  })
};
